import React from 'react';

import { Radio } from '@mui/material';
import classNames from 'classnames';

import classes from './SubscriptionCard.module.scss';
import { InitialPaymentInfo } from './InitialPaymentInfo/InitialPaymentInfo';
import { RenewalPaymentInfo } from './RenewalPaymentInfo/RenewalPaymentInfo';
import { CustomerSubscription } from '../../interfaces/customerSubscription';
import { DISCOUNT_TYPE } from '../../constants/discountType';
import { DiscountChip } from '../DiscountChip/DiscountChip';
import { getIsNonPaidSubscription } from '../../utils/getIsNonPaidSubscription/getIsNonPaidSubscription';
import { SelectableCard } from '../../../shared/components/form-components/SelectableCard/SelectableCard';

type SubscriptionCardProps = {
  subscription: CustomerSubscription;
  discountPercent?: number;
  onClick: (subscriptionId: number) => void;
};
/** Shoud be use in RadioGroup */
const SubscriptionCard = ({
  subscription,
  discountPercent,
  onClick,
}: SubscriptionCardProps) => {
  const isPaidSubscription = !getIsNonPaidSubscription(subscription.subscriptionType);

  const containerClasses = classNames(classes.container, {
    [classes.paidSubscriptionContainer]: isPaidSubscription,
  });

  const shouldShowDiscount = subscription.discountType === DISCOUNT_TYPE.PROMOCODE;

  const handleClick = () => {
    onClick(subscription.id);
  };

  return (
    <SelectableCard className={containerClasses} onClick={handleClick}>
      <Radio value={subscription.id} />
      <div className={classes.subscriptionInfoContainer}>
        <div className={classes.titleContainer}>
          <h5 className={classes.title}>{subscription.name}</h5>
          <DiscountChip show={shouldShowDiscount} discountPercent={discountPercent} />
        </div>
        {isPaidSubscription && (
          <>
            <InitialPaymentInfo
              price={subscription.initialPlanPrice}
              finalPrice={subscription.initialPlanPriceFinal}
              initialPlanDuration={subscription.initialPlanDuration}
            />
            <RenewalPaymentInfo
              billingPeriodType={subscription.billingPeriodType}
              monthlyRenewalPrice={subscription.monthlyRenewalPrice}
              monthlyRenewalPriceFinal={subscription.monthlyRenewalPriceFinal}
            />
          </>
        )}
      </div>
    </SelectableCard>
  );
};

export { SubscriptionCard };
